import { _ } from "../../core/polyglot/polyglot.js";
import { formatCurrency } from "../../core/helpers/currency-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Renders texts giving some information about the difference between
 * 2 values of a statistical series.
 *
 * @param {{}} serie - Represents the kind of data being compared. It
 * is an object with an `id`, a `name` and a `visible` boolean
 * property.
 */
export default class BusinessTrendInsightWidget extends Widget {
	constructor({ serie }) {
		super(...arguments);

		this._serie = serie;

		this._currentValue = 0;
		this._comparedValue = 0;

		this._primaryComparisonData = undefined;
		this._secondaryComparisonData = undefined;
	}

	getSerieId() {
		return this._serie.id;
	}

	setComparisonData(primaryComparisonData, secondaryComparisonData) {
		this._primaryComparisonData = primaryComparisonData;
		this._secondaryComparisonData = secondaryComparisonData;

		this.update();
	}

	setValues({ currentValue, comparedValue }) {
		this._currentValue = currentValue;
		this._comparedValue = comparedValue;
		this.update();
	}

	renderContentOn(html) {
		if (!this._serie.visible) {
			return;
		}

		html.div(
			{ klass: "insight" },
			html.h3(
				_(
					"{serie} is {upDown} in {currentPeriod} compared with {comparedPeriod}",
					{
						serie: this._serie.name,
						currentPeriod: this._comparisonDataPeriodNameRenderer(
							this._primaryComparisonData,
						),
						comparedPeriod: this._comparisonDataPeriodNameRenderer(
							this._secondaryComparisonData,
						),
						upDown: this._upDownLabel(),
					},
				),
			),
			_(
				"The {serie} for {currentPeriod} is {upDown} by {amount} compared with {comparedPeriod}.",
				{
					serie: this._serie.name.toLowerCase(),
					currentPeriod: this._comparisonDataPeriodNameRenderer(
						this._primaryComparisonData,
					),
					comparedPeriod: this._comparisonDataPeriodNameRenderer(
						this._secondaryComparisonData,
					),
					upDown: this._upDownLabel(),
					amount: this._computeAmount(),
				},
			),
			" ",
			_(
				"Go to {businessActivityLink} to see what happened during the period.",
				{
					businessActivityLink: html.a(
						{ href: this._linkTo("business-activity", {}) },
						_("#business-activity-document"),
					),
				},
			),
		);
	}

	_comparisonDataPeriodNameRenderer(comparisonData) {
		return comparisonData.getPeriodNameRenderer({ router: this._router });
	}

	_computeAmount() {
		return formatCurrency(
			Math.abs(this._currentValue - this._comparedValue),
		);
	}

	_upDownLabel() {
		return this._currentValue > this._comparedValue ? _("up") : _("down");
	}
}
